<template>
  <div class="fixed flex flex-col items-center top-0 h-screen w-screen pt-20 px-10 pb-10 z-10 bg-white" :class="[show ? 'show-previous-list' : 'hide-previous-list']">
    <!-- BACK BUTTON -->
    <div class="flex items-center justify-between w-full mb-2">
      <button class="w-20 h-10 rounded border-2 border-black font-black focus:outline-none hover:shadow-lg button-back" @click="goBack">
        Back
      </button>
      <h1 class="text-3xl font-black">Previous List</h1>
    </div>
    <!-- PREVIOUSL LIST DISPLAY -->
    <div class="w-full h-full rounded border-2 border-black overflow-y-auto bg-white">
      <!-- SPINNER FOR DATA PRELOADING -->
      <hash-loader
          class="mx-auto mt-40"
          :loading="data.length < 1"
          color="#38A169"
          :size="75"
          sizeUnit="px"></hash-loader>
      <div
        class="w-full align-center p-2 relative"
        v-for="item in data"
        :class="[item.id % 2 === 0 ? 'bg-white' : 'bg-gray-300']"
        :key="item.id">
        <div class="text-center text-xs relative" v-html="hightlighter(item)"></div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { HashLoader } from '@saeris/vue-spinners'

import { baseUrl } from '@/config';
import { display } from '@/data';
import entityTypes from '@/entityTypes';

export default {
  components: {
    HashLoader
  },
  props: ['show', 'goBack', 'data'],
  data() {
    return {
      sentences: '',
    }
  },
  methods: {
    /**
     * Escape some special character
     * @param {string} namedEntity - the named entity to be escaped
     */
    escapeRegExp(namedEntity) {
      return namedEntity.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
    },
    /**
     * process to higlight namedEntity and give color
     * and then set the currentSentence to displayed on the screen
     * @param {object} DATA - Text to be highlighted
     */
    hightlighter(data) {
      const find = data.entities

      let str = data.text;
      for (let i = 0; i < find.length; i++) {
        str = str.replace(new RegExp(this.escapeRegExp(find[i].namedEntity) + "(?![^>]*<p)"), match => {
          const color = entityTypes.filter(content => content.name === find[i].entity_type)[0].color;
          return `<span style="color: ${color};" class="relative inline-block mt-3">${match}<p style="background: ${color};visibility: visible;padding: .5px;color: #000;text-align: center;border-radius: 6px;position: absolute;z-index: 1;font-size: .6rem; bottom: 80%;left: 0;">${find[i].entity_type}</p></span>`;
        });
      }

      return str;
    },
  },
}
</script>

<style>
.hide-previous-list {
  transform: translateX(100vw);
  transition: linear 300ms;
}

.show-previous-list {
  transform: translateX(0);
  transition: linear 300ms;
}
</style>